import moment from 'moment'

export const datePattern = 'YYYY-MM-DD'

export const momentFromDate = date =>
  date ? (date.isMoment ? date : moment(date, datePattern)) : moment()

export const dayFormat = date => date.format(datePattern)

// ----------------------------------------------------------------- GENERAL HELPERS

export const addDaysToString = (dateString, numberOfDays) => {
  return momentFromDate(dateString)
    .add(numberOfDays, 'days')
    .format(datePattern)
}

const calculateFormat = (startDate, endDate, longFormat = false) => {
  if (startDate.get('year') !== endDate.get('year')) {
    return longFormat ? 'Do MMMM YYYY' : 'Do MMM'
  }

  if (startDate.get('month') !== endDate.get('month')) {
    return longFormat ? 'Do MMMM' : 'Do MMM'
  }

  return 'Do'
}

export const daysOfWeek = [
  {
    label: 'Monday',
    value: 1,
  },
  {
    label: 'Tuesday',
    value: 2,
  },
  {
    label: 'Wednesday',
    value: 3,
  },
  {
    label: 'Thursday',
    value: 4,
  },
  {
    label: 'Friday',
    value: 5,
  },
  {
    label: 'Saturday',
    value: 6,
  },
  {
    label: 'Sunday',
    value: 7,
  },
]

export const truncateDay = day => day.slice(0, 3)

// As moment.js has sunday as 0 (while the au gov has as 7)
export const isWeekend = dayNumber => [6, 7, 0].includes(dayNumber)


// ----------------------------------------------------------------- WEEK HELPERS

export const startOfWeek = date => momentFromDate(date).startOf('isoWeek')
export const endOfWeek = date => momentFromDate(date).endOf('isoWeek')

export const nextWeek = date => momentFromDate(date).add(7, 'days')
export const prevWeek = date => momentFromDate(date).subtract(7, 'days')

export const weekStartFormatted = (date, longFormat = false) => {
  const startDate = momentFromDate(date)

  return `${startDate.format(longFormat ? 'Do MMMM YYYY' : 'Do MMM')}`
}

export const weekFormatted = (date, longFormat = false) => {
  const startDate = momentFromDate(date)
  const endDate = endOfWeek(startDate)

  return `${startDate.format(calculateFormat(startDate, endDate, longFormat))} - ${endDate.format(
    longFormat ? 'Do MMMM YYYY' : 'Do MMM'
  )}`
}



// WEBPACK FOOTER //
// ./src/week/index.js